import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { ITableModelDefault } from 'shared/ui/TableNew'
import type { ContactsAnalyticsKeys } from 'entities/Analytics/api/types'
import type { AnalyticsComparisonEntity } from 'pages/analytics/ui'

export interface IContactsComparisonData extends ITableModelDefault {
  id: string | number
  name: string
  metrics: Record<ContactsAnalyticsKeys, number>
  breakdownEntity?: AnalyticsComparisonEntity
}

export class RowContactsComparison extends RowBase<IContactsComparisonData> {
  constructor(data: IContactsComparisonData) {
    super(data)

    makeObservableRowBase(this, {
      fields: computed,
    })
  }

  get fields() {
    return {
      name: this.origin.name,
      new_contacts: this.origin.metrics.new_contacts,
      opted_out: this.origin.metrics.opted_out,
      breakdownEntity: this.origin.breakdownEntity,
    }
  }
}
